module.exports = __webpack_public_path__ + "static/media/check-ok-2.01012961.svg";